import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RejectWithMessage } from 'features/types';
import { getErrorMessage } from 'utils/error';
import { jobSeekersAPI } from 'api';
import { JobSeekerManageFormData, JobSeekerManageState } from './types';

export const getManageCommunityAdminJobSeekerFormData = createAsyncThunk<JobSeekerManageFormData, { id: string }, RejectWithMessage>(
  'community-admins-manage/get-manage-community-admin-form-data',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await jobSeekersAPI.getManageCommunityAdminJobSeekerFormData(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const initialState: JobSeekerManageState = {
  status: 'idle',
  manageFormData: null,
  error: null,
};

const jobSeekerManageCommunityAdminsSlice = createSlice({
  name: 'community-admins-manage',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getManageCommunityAdminJobSeekerFormData.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(getManageCommunityAdminJobSeekerFormData.fulfilled, (state, action: PayloadAction<JobSeekerManageFormData>) => {
      state.status = 'fulfilled';
      state.manageFormData = action.payload;
      state.error = null;
    });
    builder.addCase(getManageCommunityAdminJobSeekerFormData.rejected, (state) => {
      state.status = 'rejected';
    });
  }
});

export const { resetState } = jobSeekerManageCommunityAdminsSlice.actions;
export const manageCommunityAdminJobSeekerReducer = jobSeekerManageCommunityAdminsSlice.reducer;
